import React from "react";
import { Table, Popover, Checkbox, Pagination, Tag, message, Dropdown, Space, Typography, Button, Divider, Segmented } from "antd";
import icons from "Common/Icons";
import { connect } from "react-redux";
import utils from "utils";
import api from '../../utils/api';
import Prescription from "Pages/Others/Prescription";
import Casesheet from "Pages/Others/Casesheet";
import TherapyTab from "Pages/Others/TherapyTab";
import TheraphyProgressNote from "Pages/Others/TheraphyProgressNote";
import DSMScreening from "Pages/Others/DSMScreening";
import DiagnosisSummary from "Pages/Others/DiagnosisSummary";
import DiagnosisNewSummary from "Pages/Others/DiagnosisNewSummary";
import TreatmentSummary from "Pages/Others/TreatmentSummary";
import MHE from "Pages/Others/MHE";
import Loader from "Components/Loader";
import SearchComponent from "Components/SearchComponent";
import "./Patient.scss";
import { Link } from "react-router-dom";
import { patientDetail, gender, usertype } from "../../store/slice/patient-detail-slice";
import DOTSNewSummary from "Pages/Others/DOTSNewSummary";
import SOSSummary from "Pages/Others/SOSSummary";
import ProtectiveFactorSummary from "Pages/Others/ProtectiveFactorSummary";
import UploadDocSummary from "Pages/Others/UploadDocSummary";
import GeriatricSummary from "Pages/Others/GeriatricSummary";
import ConcogSummary from "Pages/Others/ConcogSummary";
import ConsultedCareTeam from "Pages/Others/ConsultedCareTeam";
import { CONSTANTS } from "utils/constant";
import PSTSummary from "Pages/Others/PSTSummary";
import Icons from "Common/Icons";
import VitalFormHistoryDoctor from "Pages/VitalForm/VitalFormHistoryDoctor";


class myPatientsHome extends React.Component {
  _baseClassName = "my-patient-home-container";
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: "this_month",
      user_details: this.props.user_details || {},
      myPatientsData: [],
      totalRecords: 0,
      pageNo: 1,
      defaultDate: null,
      searchName: null,
      prescription: false,
      casesheet: false,
      isLoading: false,
      checkBoxState: false,
      tablelist: [],
      netErr: "",
      openObj: {},
      geriartric: {},
      consultationStatus: {},
      allPatientsSegmentsValue: this.props.user_details.is_supervising_clinician,
      is_missed_casenotes : false
    };
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this)
    this.allPatientsSegment = this.allPatientsSegment.bind(this)
  }


  componentDidMount = () => {

    this.setState({ isLoading: true });
    this.getPatientList({ pageNo: 1, pageSize: 10 });
  }
  handleCheckboxChange(checkedValues) {
    this.setState({ checkedValues, checkBoxState: true, isLoading: true }, () => {
      this.setState({ isLoading: false })
      typeof this.handleFunction == "function" && this.handleFunction("checkbox", checkedValues);
    });
  }
  allPatientsSegment(segmentValue) {
    this.setState({ allPatientsSegmentsValue: segmentValue, isLoading: true }, () => {
      this.setState({ isLoading: false })
      typeof this.handleFunction == "function" && this.handleFunction("segmentAllPatients");
    });
  }
  patientSearchName(name) {
    this.setState({ searchName: name, pageNo: 1, pageSize: 10, isLoading: true, is_missed_casenotes :false }, () => {
      this.setState({ isLoading: false })
      this.getPatientList({ searchName: name || "", pageNo: 1, pageSize: 10, missed_casesheet: this.state.is_missed_casenotes  });
    });
  }
  handlePagination(pageNo, pageSize) {
    pageNo = pageNo || 1;
    this.setState({ pageNo, pageSize, isLoading: true }, () => {
      this.setState({ isLoading: false })
      this.getPatientList({ pageNo, pageSize, searchName: this.state.searchName || "", missed_casesheet: this.state.is_missed_casenotes })
    });
  }
  getPatientList(data) {
    this.setState({ isinnerLoading: true });
    let { selectedTab = "this_month",
      pageNo = pageNo || 1,
      pageSize = pageSize || 10,
      filter = null,
      searchName = "",
      missed_prescription = false,
      missed_casesheet = false
    } = data || {}
    api.all_patients_list(searchName, missed_prescription, missed_casesheet, pageNo, pageSize, this.state.allPatientsSegmentsValue).then((res) => {
      if (res.data.status == 200) {
        let updatedValue = res.data.data.results.map(({ patient_details, ...rest }) => ({ ...patient_details, ...rest }));
        this.setState({ tablelist: updatedValue, count: res.data?.data?.count || "", pageNo, pageSize })
      } else {
        message.error(res.data.message, ErrorDuration);
      }
    }
    ).catch((err) => {
      this.setState({ netErr: err })
    }).finally(() => {
      this.setState({ isLoading: false, isinnerLoading: false });
    });
  }
  handleFunction(col, value) {
    if (col == "checkbox") {
      let is_missed_prescription = value && value.includes("missed_prescriptions") || false;
      let is_missed_casenotes = value && value.includes("missed_casenotes") || false;
      this.setState({ searchName: null, pageNo: 1, pageSize: 10, is_missed_casenotes : is_missed_casenotes });
      this.getPatientList({
        missed_prescription: is_missed_prescription,
        missed_casesheet: is_missed_casenotes,
        searchName: "",
        pageNo: 1,
        pageSize: 10
      });
    } else if (col == "segmentAllPatients") {
      this.setState({ searchName: null, pageNo: 1, pageSize: 10, is_missed_casenotes : false });
      this.getPatientList({
        missed_prescription: false,
        missed_casesheet: false,
        searchName: "",
        pageNo: 1,
        pageSize: 10,
      });
    }
  }
  handleActions(col, value, userType) {
    this.props.patientDetail(value?.patient_id)
    this.props.gender(value?.gender)
    this.props.usertype(value?.user_type)
    this.handleButtonActions(col, value, userType);
  }
  handleButtonActions(col, value, userType) {
    if (col == "health_profile") {
      let keysToRemove = ["patient_id", "patient_user_type", "patient_gender"];
      for (let key of keysToRemove) {
        localStorage.removeItem(key);
      }
      this.props.history.push({
        pathname: '/doctor/health-profile',
        patient_id: 101,
        patient_name: value?.patient_name,
        patient_uid: value.patient_uid,
        patient_last_name: value.patient_last_name
      });
    }
    else if (col == "patientsdetails") {
      this.props.history.push({
        pathname: '/doctor/my-patientsdetails',
        user_type: userType,
        state: { data: value }
      })
    }
    else if (col == "assessment") {
      this.props.history.push({
        pathname: '/doctor/assessment-history',
        patient_id: 101,
        user_type: userType,
        state: { patientName: value?.patient_name, patientUID: value.patient_uid, patient_last_name: value.patient_last_name }
      });
    } else if (col == "prescription") utils.Modal(true, { content: <Prescription data={value} from={"allPatients"}/>, width: "70vw" })
    else if (col == "Casenotes") utils.Modal(true, { content: <Casesheet data={value} />, width: "850px" })
    else if (col == "therapy_intake") utils.Modal(true, { content: <TherapyTab data={value} />, width: "850px" });
    else if (col == "tpn") utils.Modal(true, { content: <TheraphyProgressNote data={value} />, width: "850px" });
    else if (col == "dsm_screening") utils.Modal(true, { content: <DSMScreening data={value} />, width: "850px" });
    else if (col == "mhe") utils.Modal(true, { content: <MHE data={value} />, width: "850px" });
    else if (col == "diagnosis") utils.Modal(true, { content: <DiagnosisNewSummary data={value} />, width: "850px" });
    else if (col == "cf1") utils.Modal(true, { content: <DiagnosisSummary data={value} />, width: "850px" });
    else if (col == "cf2") utils.Modal(true, { content: <TreatmentSummary data={value} />, width: "850px" });
    else if (col == "pst") utils.Modal(true, { content: <PSTSummary data={value} />, width: "850px" });
    else if (col == "dots") utils.Modal(true, { content: <DOTSNewSummary data={value} />, width: "850px" });
    else if (col == "sos") utils.Modal(true, { content: <SOSSummary data={value} />, width: "850px" });
    else if (col == "protective_factor") utils.Modal(true, { content: <ProtectiveFactorSummary data={value} />, width: "850px" });
    else if (col == "custom-doc") utils.Modal(true, { content: <UploadDocSummary data={value} />, width: "850px" });
    else if (col == "confas") utils.Modal(true, { content: <GeriatricSummary title={"CONFAS"} data={value} />, width: "850px" });
    else if (col == "conpsyq") utils.Modal(true, { content: <GeriatricSummary title={"CONPSYQ"} data={value} />, width: "850px" });
    else if (col == "concog") utils.Modal(true, { content: <ConcogSummary data={value} />, width: "850px" });
    else if (col == "careTeam") utils.Modal(true, { content: <ConsultedCareTeam data={value} />, width: "600px" });
    else if (col == "med-doc") {
      this.props.history.push({
        pathname: "document-upload",
        patient_id: value.patient_id,
        data:value,
      });
    }
    else if (col == "vital") utils.Modal(true, { content: <VitalFormHistoryDoctor data={value} isEditable={true} isChartShow={true}/>, width: "70vw" })
  }
  getItem(supported = true, label, key, icon, children, type) {
    if (supported)
      return {
        key,
        icon,
        children,
        // label,
        label:
          <div>
            <div className="dropdown-allPatients-label"><div>{label}</div>
            {children && <img src={Icons.allPatients_arrow_icon} />}
            </div>
            <Divider className="allPatients-divider" />
          </div>,
        type,
      };
    return '';
  }
  render() {
    let columns = [
      {
        title: <div className="table-heading-allPatients">{CONSTANTS.NAME_CAPITAL}</div>, align: "", render: (data) => (
          <div className="patient-name patient-name-allPatients" style={{ fontSize: "14px", fontWeight: "500", float: "left", textAlign: "left" }} >
            <div>{utils.FirstNameLastNameLink(utils.FormatName(utils.getDisplayName(data.patient_name, data.patient_last_name)), "190px")}</div>
            <div className="allPatients-content">{utils.ConvertToPascalCase(data?.gender)}, {data.age} {CONSTANTS.YEARS}</div>
          </div>
        ), key: "patient_id"
      },
      {
        title: <div className="table-heading-allPatients">{CONSTANTS.PATIENTID}</div>,
        align: "",
        render: (data) => (
          <div>
            <div className="allPatients-content">{data.patient_uid}</div>
            {(data?.is_my_patient && this.props.user_details.is_supervising_clinician && this.state.allPatientsSegmentsValue) ? <div className="seenby-me">{CONSTANTS.SEEN_BY_ME}</div> : ""}
          </div>
        ),
        key: "patient_id",
      },
      {
        title: <div className="table-heading-allPatients">{CONSTANTS.LAST_cONSULTATION_CAPITAL}</div>,
        align: "",
        render: (data) => (
          <><div className="allPatients-content">{data.last_consultation_date_time && (
            <div className="allPatients-date">
              <span>{utils.FormatDate(data?.last_consultation_date_time, "DATE_14")}</span>
              <span>{utils.FormatDate(data?.last_consultation_date_time, "TIME_1")}</span>
            </div>)}</div>
            {!data.last_consultation_date_time && <span className="hyphen-allPatients">-</span>}
          </>
        ),
        key: "patient_id",
      },
      {
        title: <div className="table-heading-allPatients">{CONSTANTS.NEXT_APP_TABLE}</div>,
        align: "",
        render: (data) => (
          <>
            <div className="allPatients-content">{data.next_consultation_date_time && (
              <div className="allPatients-date">
                <span>{utils.FormatDate(data?.next_consultation_date_time, "DATE_14")}</span>
                <span>{utils.FormatDate(data?.next_consultation_date_time, "TIME_1")}</span>
              </div>)}</div>
            {!data.next_consultation_date_time && <span className="hyphen-allPatients">-</span>}
          </>
        ),
        key: "patient_id"
      },
      {
        title: <div className="table-heading-allPatients">{CONSTANTS.PLAN_DETAILS_CAPITAL}</div>,
        align: "",
        render: (data) =>
          data?.plan_details?.display_plan_name ? (
            <div style={{ float: "left", textAlign: "left" }}>
              <div className="allPatients-content">{data.plan_details.display_plan_name}</div>
              <div className="expires-availed-allPatients">
                {data?.plan_details?.is_membership_benefits_availed ? <div className="allPatients-expires">
                  {CONSTANTS.AVAILED_ON_NEW}
                  <span className="expired-expires-allpatient">{utils.FormatDate(data?.plan_details?.membership_benefits_availed_date, "DATE_14")}</span>
                </div>
                  : <div className="allPatients-expires">
                    <div>
                      {data?.plan_details?.is_membership_active ? CONSTANTS.EXPIRES_ON : CONSTANTS.EXPIRED_ON}
                      <span
                        className="expired-expires-allpatient"
                      //  className={data?.plan_details?.is_membership_active ? "expires-allPatient" : "expired-allPatient"}
                      >
                        {utils.FormatDate(
                          data.plan_details?.expiry_date,
                          "DATE_14"
                        )}
                      </span>
                    </div>
                  </div>
                }
              </div>
            </div>
          ) : (
            "-"
          ),
        key: "patient_id",
      },
      // {
      //   title: <div className="table-heading-allPatients">{CONSTANTS.ORGANIZATION}</div>,
      //   align: "",
      //   render: (data) => data?.org_name ? (<div className="Organisation-allPatients">
      //     <ul className="allPatients-orgname"><li>{data?.org_name}</li></ul></div>) : (<span className="hyphen-allPatients">-</span>),
      //   key: "patient_id",
      // },
      {
        title: <></>,
        align: "",
        key: 'actions',
        render: (data, record) => {
          let id = record.patient_uid;
          let status = record.consultation_status;
          let items = [
            this.getItem(true, CONSTANTS.CONSULTATION_HISTORY, 'patientsdetails'),
            this.getItem(this.props.user_details.is_supervising_clinician, CONSTANTS.CONSULTED_DOCTORS, 'careTeam'),
            this.getItem(status?.is_phi, CONSTANTS.HEALTH_INFORMATION, 'health_profile',),
            // this.getItem(status?.is_assessment,
            //   CONSTANTS.ASSESSMENTS,
            //   'assessment'),
            this.getItem(status?.is_casenotes,
              CONSTANTS.C_NOTES,
              'Casenotes',),
            this.getItem(status?.is_prescription,
                CONSTANTS.PRESCRIPTION,
                'prescription',),
            // this.getItem((status?.is_dsm || status?.is_mse || status?.is_theraphy || status?.is_tpn),
            //   CONSTANTS.GEN_ASSESS,
            //   'gen_assess',
            //   "",
            //   [
            //     this.getItem(status?.is_dsm,
            //       CONSTANTS.DSM,
            //       'dsm_screening',
            //     ),
            //     this.getItem(status?.is_mse,
            //       CONSTANTS.MSE,
            //       'mhe',
            //     ),
            //     this.getItem(status?.is_theraphy,
            //       CONSTANTS.PSY,
            //       'therapy_intake',
            //     ),
            //     this.getItem(status?.is_tpn,
            //       CONSTANTS.TPN,
            //       'tpn',
            //     ),
            //   ],
            // ),
            // this.getItem((status?.is_protective_factor || status?.is_dot || status?.is_sos),
            //   CONSTANTS.STRESS_MNG,
            //   'stress_mng',
            //   "",
            //   [
            //     this.getItem(status?.is_protective_factor,
            //       CONSTANTS.PFACT,
            //       'protective_factor',
            //     ),
            //     this.getItem(status?.is_dot,
            //       CONSTANTS.DOTS,
            //       'dots',
            //     ),
            //     this.getItem(status?.is_sos,
            //       CONSTANTS.SOS,
            //       'sos',
            //     ),
            //   ],
            // ),
            // this.getItem((status?.is_case_formulation1 || status?.is_case_formulation2 || status?.is_psychiatry_fb),
            //   CONSTANTS.FEED_RPT,
            //   'feed_rpt',
            //   "",
            //   [
            //     this.getItem(status?.is_case_formulation1,
            //       CONSTANTS.CF1,
            //       'cf1',
            //     ),
            //     this.getItem(status?.is_case_formulation2,
            //       CONSTANTS.CF2,
            //       'cf2',
            //     ),
            //     this.getItem(status?.is_psychiatry_fb,
            //       CONSTANTS.PST,
            //       'pst',
            //     ),
            //   ],
            // ),
            this.getItem(status?.is_diagnosis, CONSTANTS.DIAGNOSIS, 'diagnosis',),
            this.getItem(status?.is_vital, CONSTANTS.VITALS, 'vital',),
            // this.getItem(status?.is_document_upload, CONSTANTS.ESSENTIAL_Q, 'custom-doc',),
            // this.getItem((status?.is_concog || status?.is_conpsyg || status?.is_confas),
            //   CONSTANTS.GERIATRIC,
            //   'geriatric',
            //   "",
            //   [
            //     this.getItem(status?.is_concog,
            //       CONSTANTS.CONCOG,
            //       'concog',
            //     ),
            //     this.getItem(status?.is_conpsyg,
            //       CONSTANTS.CONPSYQ,
            //       'conpsyq',
            //     ),
            //     this.getItem(status?.is_confas,
            //       CONSTANTS.CONFAS,
            //       'confas',
            //     ),
            //   ],
            // ),
            this.getItem(status?.is_medical_document, CONSTANTS.MEDICAL_DOCUMENT, 'med-doc',),
          ];
          return (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div className="" onClick={() => this.props.patientDetail(data.patient_id)}>  <Link className="allPatients-viewDetails" to={{ pathname: '/doctor/patient-detail', state: { data: data, all_patients: true } }}>{CONSTANTS.VIEW_DETAILS}</Link></div>
              <Dropdown
                className="dropdown-id-allPatients"
                menu={{
                  className: 'dropdown-menu-allPatients',
                  items,
                  onClick: ({ key }) => {
                    this.handleActions(key, data, data?.user_type || "adult")
                  }
                }}
                placement="bottomRight"
              >
                <a onClick={(e) => e.preventDefault()}>
                  <Space>
                    <img src={icons.action_dots} />
                  </Space>
                </a>
              </Dropdown>
            </div>
          )
        },
      },

    ];
    let showFilter = this.state.tablelist.length > 0 || this.state.defaultDate || this.state.searchName ? true : false;
    if (this.state.netErr !== "") {
      throw new Error(this.state.netErr)
    }
    return (
      <>
        {
          this.state.isLoading ? <Loader /> :
            <div className={this._baseClassName}>
              <div className="main-content">
                <div className="main-content-top">
                  {/* <div className={`main-content-header`}>{CONSTANTS.MY_PATIENTS}</div> */}
                  <div className="search-missed">
                    {/* <div className="all-patient-header">
                      {CONSTANTS.PATIENTS}
                    </div> */}
                    <div>
                      {this.props.user_details.is_supervising_clinician && <div>
                      <Segmented options={[{ label: (<span className="label-myPatients-allPatients">{CONSTANTS.ALL_PATIENTS_SEGMENT}</span>), value: true }, { label: (<span className="label-myPatients-allPatients">{CONSTANTS.MY_PATIENTS_SEGMENT}</span>), value: false, },]} onChange={this.allPatientsSegment} value={this.state.allPatientsSegmentsValue}
                      // value={true} 
                      />
                      </div>}
                    </div>
                    <div className="missedCasenotes-searchPatient">
                    {/* {showFilter && <div className="missed-casenotes-allPatient">
                      <Checkbox.Group className="mypatient-check" onChange={this.handleCheckboxChange} value={this.state.is_missed_casenotes ? "missed_casenotes" : ""}>
                        <div>
                          <Checkbox className="missedCasenotes-text" value="missed_casenotes">{CONSTANTS.MISSED_CASENOTES}</Checkbox>
                        </div>
                      </Checkbox.Group>
                    </div>} */}
                    <div>
                      {showFilter && <SearchComponent myPatients={true} allPatients={this.state.allPatientsSegmentsValue} defaultValue={this.state.searchName}
                        onChange={this.patientSearchName.bind(this)} enabled={true}
                      />}
                    </div>  
                    </div>                  
                  </div>
                  <Table columns={columns}
                    bordered={true}
                    scroll={{ x: "auto" }}
                    dataSource={this.state.tablelist}
                    loading={this.state.isinnerLoading}
                    pagination={false}
                    size={"small"}
                  />
                  <div className="patient-table-pagination"><Pagination className='table-pagination' hideOnSinglePage={this.state.count <= 0 ? true : false} defaultPageSize={this.state.pageSize} current={this.state?.pageNo || 1} defaultCurrent={this.state?.pageNo || 1} total={this.state.count} onChange={this.handlePagination.bind(this)} pageSizeOptions={[5, 10, 20, 50, 100]} showSizeChanger={true} />
                  </div>
                </div>
              </div>
            </div>
        }
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    user_details: state.loginReducer.user_details,
  };
};
const mapDispatchToProps = {
  patientDetail,
  gender,
  usertype
};
export default connect(mapStateToProps, mapDispatchToProps)(myPatientsHome)